import { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { Box, Skeleton } from '@mui/material';

interface SmartImageProps {
    src: string;
    alt: string;
    size?: number | string;
    borderRadius?: number;
    imageStyle?: React.CSSProperties
}

export const SmartImage = ({
    src,
    alt,
    size,
    borderRadius = 25,
    imageStyle
}: SmartImageProps) => {
    const [loaded, setLoaded] = useState(false);
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

    return (
        <Box ref={ref} sx={{ width: size, height: size, position: 'relative' }}>
            {!loaded && (
                <Skeleton
                    variant="rounded"
                    width={size}
                    height={size}
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        borderRadius,
                        bgcolor: 'rgba(200,200,200,0.2)',
                    }}
                />
            )}
            {inView && (
                <img
                    src={src}
                    alt={alt}
                    onLoad={() => setLoaded(true)}
                    style={{
                        opacity: loaded ? 1 : 0,
                        transition: 'opacity 0.4s ease-in-out',
                        ...imageStyle,
                    }}
                />
            )}
        </Box>
    );
};
